import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPath } from '../../pages/Pages';

/**
 * Cierra una página que se pinta como diálogo: vuelve a la anterior si se llegó
 * navegando y, si se entró directamente por la URL, al cuadrante, que es la
 * pantalla de inicio del gestor.
 */
export function useCloseToPreviousPage(): () => void {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(() => {
        // react-router marca la primera entrada del historial con la clave
        // 'default': ahí no hay atrás al que volver dentro de la aplicación.
        if (location.key === 'default') {
            navigate(getPath('timetable'), { replace: true });
            return;
        }

        navigate(-1);
    }, [location.key, navigate]);
}
